/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import ReactSVG from 'react-svg';
import { BrandColors } from '@blend/enterprise-components';

const styles = StyleSheet.create({
  header: {
    marginBottom: 24,
  },
  innerAppContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'flex-start',
  },
  innermostAppContainer: {
    display: 'flex',
    flexBasis: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: `42px 0`,
    width: 480,
  },
  outerAppContainer: {
    backgroundColor: BrandColors.NIGHT_90,
    height: '100vh',
    overflow: 'auto',
    width: '100vw',
  },
});

export namespace AppContainer {
  export interface Props {}
}

export const AppContainer: React.FC<AppContainer.Props> = ({ children }) => {
  return (
    <div className={css(styles.outerAppContainer)}>
      <div className={css(styles.innerAppContainer)}>
        <div className={css(styles.innermostAppContainer)}>
          <div className={css(styles.header)}>
            <ReactSVG path="./assets/blend-header-white.svg" />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
